import {Injectable} from '@angular/core';
import {Room} from '../classes/Room';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

@Injectable({
  providedIn: 'root'
})
export class RoomService {

  constructor(private httpClient: HttpClient) { }

  public getAll(): Observable<Room[]> {
    return this.httpClient.get<Room[]>(`${environment.backendApiUrl}/v1/rooms`, httpOptions);
  }

  public getByOffice(officeId: number): Observable<Room[]> {
    return this.httpClient.get<Room[]>(`${environment.backendApiUrl}/v1/rooms/office/` + officeId, httpOptions);
  }

  public addOrEdit(formData: FormData): Observable<void> {
    return this.httpClient.post<void>(`${environment.backendApiUrl}/v1/rooms`, formData);
  }

  public delete(id: number): Observable<void> {
    return this.httpClient.delete<void>(`${environment.backendApiUrl}/v1/rooms/` + id, httpOptions);
  }

  public deleteImage(id: number): Observable<void> {
    return this.httpClient.delete<void>(`${environment.backendApiUrl}/v1/rooms/` + id + '/image', httpOptions);
  }
}
